// The support mailbox: linked with a `mailto:` by the membership tab and the
// crash page, and spelled out on the /support page.
export const SUPPORT_EMAIL = "support@usnara.com";
